import axios from 'axios';

const API_URL = 'https://dailyreportsapi.winggs.in/api';
// const API_URL = 'http://localhost:5000/api'; // Use this for local development

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { 'x-auth-token': token } : {};
};

// Get all tasks with pagination and optional status filter
const getAllTasks = async (page = 1, limit = 10, status = null) => {
  const params = { page, limit };
  
  // Add status filter if provided
  if (status) params.status = status;
  
  const response = await axios.get(`${API_URL}/tasks`, {
    headers: getAuthHeaders(),
    params
  });
  return response.data;
};

// Get tasks by project ID with pagination and optional status filter
const getTasksByProject = async (projectId, page = 1, limit = 10, status = null) => {
  const params = { page, limit };
  
  // Add status filter if provided
  if (status) params.status = status;
  
  const response = await axios.get(`${API_URL}/tasks/project/${projectId}`, {
    headers: getAuthHeaders(),
    params
  });
  return response.data;
};

// Get task by ID
const getTaskById = async (taskId) => {
  const response = await axios.get(`${API_URL}/tasks/${taskId}`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

// Create a new task
const createTask = async (taskData) => {
  const response = await axios.post(`${API_URL}/tasks`, taskData, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

// Update task
const updateTask = async (taskId, taskData) => {
  const response = await axios.put(`${API_URL}/tasks/${taskId}`, taskData, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

// Update task status
const updateTaskStatus = async (taskId, statusData) => {
  const response = await axios.post(`${API_URL}/tasks/${taskId}/status`, statusData, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

// Get task statistics
const getTaskStats = async () => {
  const response = await axios.get(`${API_URL}/tasks/stats/summary`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

// Delete a task
const deleteTask = async (taskId) => {
  const response = await axios.delete(`${API_URL}/tasks/${taskId}`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

const taskService = {
  getAllTasks,
  getTasksByProject,
  getTaskById,
  createTask,
  updateTask,
  updateTaskStatus,
  getTaskStats,
  deleteTask
};

export default taskService;
